import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteRecipe } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function useDeleteRecipe() {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (recipeId: string) => {
      const token = await getToken();
      if (!token) throw new Error("Not authenticated");
      return deleteRecipe(recipeId, token);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["recipes"] });
    },
  });
}
